export default "__VITE_ASSET__36385a44__"